import React, { FC, useEffect, useState } from 'react';
import Arrow from '../../../../static/icons/arrow.inline.svg';
import Icon from '@ant-design/icons';
import markdownToReact from 'logic/markdown/markdown';
import { Collapse } from 'antd';
import { colors } from 'src/styles/colors';
import styled from 'styled-components';

const { Panel } = Collapse;

const ArrowIcon = (props: any) => <Icon component={Arrow} {...props} />;

const FAQCollapseWrapper = styled(Collapse)`
  img, video, audio {
    width: 100%;
  }
`;

type Props = {
  quoteAuthor: string;
  content: string;
  idx: number;
  active: number;
};

export const FAQList: FC<Props> = ({ quoteAuthor, content, active, idx }) => {
  const [open, setOpen] = useState<string | string[]>();

  useEffect(() => {
    setOpen('');
  }, [active]);

  return (
    <FAQCollapseWrapper
      expandIconPosition="right"
      expandIcon={({ isActive }) => (
        <ArrowIcon
          style={{ color: !isActive ? colors.blueGray : colors.primary }}
          rotate={isActive ? 180 : 0}
        />
      )}
      activeKey={open}
      ghost
      bordered={false}
      onChange={(key) => {
        setOpen(key);
      }}
    >
      <Panel header={quoteAuthor} key={idx}>
        {markdownToReact(content)}
      </Panel>
    </FAQCollapseWrapper>
  );
};
